<script setup lang="ts">
definePageMeta({
  name: 'home',
  layout: false,
  colorMode: 'light',
  theme: 'blurple',
  breadcrumb: {
    label: 'Hjem',
  },
})

useHead({
  htmlAttrs: {
    class: 'bg-carbon-50',
  },
  bodyAttrs: {
    class: 'bg-carbon-50',
  },
})

const { data: cmsData, suspense } = useFrontPageCmsData()

await suspense()

const description = computed(() => getTextContent(cmsData.value?.components?.leadParagraph))

useSeoMeta({
  description,
  ogDescription: description,
})
</script>

<template>
  <NuxtLayout name="nettbutikk" :show-breadcrumbs="false" class="overflow-x-hidden">
    <div class="flex flex-col gap-l">
      <ContentGrid>
        <FrontPageHeader
          :title="cmsData?.components?.title"
          :lead-paragraph="cmsData?.components?.leadParagraph"
          :header-image="cmsData?.components?.headerImage"
          :primary-action="cmsData?.components?.topSectionAction"
          :secondary-action="cmsData?.components?.secondaryTopSectionAction"
        />
      </ContentGrid>

      <template v-for="(block, i) in cmsData?.components?.body" :key="i">
        <FrontPageChangesCta v-if="block.type === 'changes-article-cta'" :data="block.value" />
        <FrontPageQuote v-else-if="block.type === 'quote'" :data="block.value" />
        <FrontPageArticles
          v-else-if="block.type === 'article-cards'"
          :title="block.value.title"
          :max-count="block.value.maxCount"
          :show-overview-link="block.value.showOverviewLink"
        />
        <FrontPageUspGrid
          v-else-if="block.type === 'usp-list'"
          :title="block.value.title"
          :usps="block.value.usp"
        />
        <FrontPageProductsCta v-else-if="block.type === 'products-cta'" :data="block.value" />
        <FrontPageTestimonials v-else-if="block.type === 'testimonials'" :data="block.value" />
        <FrontPageStats v-else-if="block.type === 'stats'" :data="block.value" class="w-full" />
        <FrontPageHighlightedArticle v-else-if="block.type === 'highlighted-article'" :data="block.value" />
      </template>
    </div>
  </NuxtLayout>
</template>
